module.exports = __webpack_public_path__ + "static/smiling-woman-relaxing-with-phone-in-bed-P6Z83NV-3d196d36b25412d74e0c34065020956f.jpg";